import SchemaProperties from "./SchemaProperties";
export default SchemaProperties